"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUuidMin = exports.getUuid = exports.generateKey = void 0;

/**
 * Function to generate a key from th actual Date and Math.random()
 */
var getUuid = function getUuid() {
  return "".concat(new Date().getTime(), "_").concat(Math.random().toString().replace(".", ""));
};

exports.getUuid = getUuid;

var getUuidMin = function getUuidMin() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var uid;
  if (param) uid = param;else uid = getUuid();
  var hash = 0,
      i,
      chr;
  if (uid.length === 0) return hash;

  for (i = 0; i < uid.length; i++) {
    chr = uid.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }

  return hash;
};
/**
 * Function to generate a concatenated key
 * @param {Object} obj
 * @param {Array} fields
 * @param {String} separator
 */


exports.getUuidMin = getUuidMin;

var generateKey = function generateKey(obj, fields) {
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "_";
  var keys = fields.map(function (field) {
    return obj[field];
  }).filter(function (item) {
    return item;
  }).join(separator);
  return keys;
};

exports.generateKey = generateKey;